const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5437e86dc7ee8135fa1b22b886d73124e67effac"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sprout@sprout-place"]={id:"5437e86dc7ee8135fa1b22b886d73124e67effac"};
      